import { Card, CardHeader } from "@mui/material";
import React from "react";
import { withTranslation } from "react-i18next";
import { getDocumentTypes } from "../../../data/enums";
import logger from "../../../services/logger";
import Form from "../../common/form";
import {
  getFormButtonText,
  getFormTitleText,
  getJoiSchema,
  getStateObject,
} from "../../common/formUtils";
import academicCourseService from "./academicCourseService";
import programService from "../../../services/programService";
import termDataService from "../../../services/termDataService";
import academicCourseJson from "./academicCourse.json"
class AcademicCourseForm extends Form {
  constructor() {
    super();
    this.formJson = academicCourseJson;
    this.state = {
      data: getStateObject(this.formJson.groups),
      errors: {},
      dropDowns: {},
    };
    this.schema = getJoiSchema(this.formJson.groups);
  }

  async componentDidMount() {
    await this.populateForm();
    this.getEnumValue();
    this.getPrograms();
  }

  getEnumValue() {
    try {
      const documentTypes = getDocumentTypes();

      const dropDowns = { ...this.state.dropDowns };

      dropDowns["documentTypes"] = documentTypes;

      this.setState({ dropDowns });
    } catch (ex) {
      logger.error("applicationFormStatus ", ex);
    }
  }


  getPrograms = async () => {
    //console.log("instituteId :", instituteId);
    try {
      const { data } = await programService.getAll();
      const dropDowns = { ...this.state.dropDowns };
      dropDowns["programs"] = data;
      this.setState({ dropDowns });
      if(this.state.data.programId)
        await this.getTermsByProgram(this.state.data.programId)
    } catch (ex) {
      logger.error(ex);
    }
  };
  getTermsByProgram = async (programId) => {
    try {
      const { data:terms } =await termDataService.getAllByProgram(programId);

      const dropDowns = { ...this.state.dropDowns };
      dropDowns["terms"] = terms;
      const data={...this.state.data}
      data["termId"]=terms[0].id;
      this.setState({ data,dropDowns,termId:terms[0].id });
    } catch (ex) {
      logger.error(ex);
    }
  };
  onSelectOf = async (item, value) => { 
    switch (item) {
      case "programId":
        await this.getTermsByProgram(value);
        break;
    }
  };

  async populateForm() {
    const id = this.props.match.params.id;
    if (id === "new") return;
    try {
      const { data } = await academicCourseService.get(id);
      this.mapToViewModel(data);
    } catch (ex) {
      logger.error(ex);
    }
  }



  doSubmit = async (id) => {
    try {
      if (id === "new") {
        await academicCourseService.create(this.state.data);
      } else {
        await academicCourseService.update(this.state.data);
      }
      this.props.history.goBack();
    } catch (ex) {
      logger.log(ex);
    }
  };

  render() {
    const { t } = this.props;
    const { dropDowns } = this.state;
    const id = this.props.match.params.id;

    const buttonText = getFormButtonText(id);

    const titleText = getFormTitleText(id, this.formJson.alias);

    return (
      <Card>
        <form onSubmit={(event) => this.handleSubmit(event, id)}>
          <CardHeader title={t(titleText)} />

          {this.renderForm(this.formJson, dropDowns)}

          {/* <CardContent>
            <Grid container item sm={12} md={12} direction="row-reverse">
              {this.renderMatButton(t(buttonText))}
              {this.renderMatButton(t("common:Reset"), "reset", "secondary")}
            </Grid>
          </CardContent> */}
        </form>
      </Card>
    );
  }
}

export default withTranslation(["admissionCalendar", "common"])(
  AcademicCourseForm
);
